<section class="g-brd-bottom g-brd-gray-light-v4 g-py-30 breadcrumbs">
    <div class="container">
        <ul class="d-flex justify-content-between u-list-inline">
            <li class="list-inline-item g-mr-15">
                <a class="u-link-v5 g-color-text g-pr-10" routerLink="/">Home</a>
                <i class="g-color-gray-light-v2 g-ml-5 fa fa-angle-right"></i>
            </li>
            <li class="list-inline-item g-color-primary">
                <span>NSIA AT 30</span>
            </li>
        </ul>
    </div>
</section>
<div class="row">
    <div class="container g-pt-100 g-pb-70" style="margin-top: -50px">
        <div class="row">
            <div class="col-lg-9 g-mb-30">
                <article class="text-center">
                    <header class="g-mb-30">
                        <h1 class="g-color-black g-font-weight-600 text-uppercase g-mb-15">NSIA AT 30</h1>
                        <p class="g-color-gray-dark-v2 g-font-size-16 g-mb-30">
                            <i class="fa fa-calendar g-mr-5"></i> March 17, 2025
                        </p>
                    </header>

                    <figure class="g-mb-40">
                        <img
                            src="../../../assets/vendor/revolution-slider/revolution/assets/svg/av/NSIA @ 30.jpg"
                            alt="NSIA Insurance Mother's Day 2025"
                            class="img-fluid rounded mx-auto d-block"
                            style="max-width: 100%"
                        />
                    </figure>

                    <div class="g-mb-30 text-center">
                        <p class="lead g-mb-30" style="font-weight: 600">
                            30 Years Strong: NSIA Insurance Celebrates a Legacy of Trust and Innovation
                        </p>
                    </div>

                    <div class="article-content g-line-height-1_8 g-mb-30 text-center">
                        <p class="g-mb-30">
                            To mark three decades of excellence, NSIA Insurance hosted an exclusive celebration in
                            Lagos, bringing together board members, industry leaders, corporate clients, brokers, and
                            the media to celebrate this remarkable achievement.
                        </p>

                        <p class="g-mb-30">
                            From its humble beginnings to becoming a household name across Nigeria and West Africa, NSIA
                            Insurance has built a legacy rooted in trust, resilience, and customer-first service. Over
                            the past ten years alone, the company has paid out
                            <strong>over ₦44 billion in claims</strong>, an incredible testament to its reliability and
                            unwavering support for clients.
                        </p>

                        <blockquote
                            class="g-brd-primary g-brd-left g-brd-3 g-pa-20 g-mb-30 text-center mx-auto"
                            style="max-width: 80%"
                        >
                            <p class="g-font-style-italic g-font-size-18">
                                "This milestone reflects the dedication of our staff, the loyalty of our clients, and
                                the strong partnerships we've nurtured over the years."
                            </p>
                            <footer class="g-color-primary">Dr. Adesegun Akin-Olugbade (OON), Chairman</footer>
                        </blockquote>

                        <p class="g-mb-30">
                            Managing Director Moruf Apampa highlighted NSIA's transformation into a forward-thinking,
                            digitally driven company. "We're not just celebrating the past, we're stepping boldly into
                            the future, committed to innovation, expansion, and adding value for our stakeholders," he
                            said.
                        </p>

                        <div class="g-bg-gray-light-v5 g-pa-30 g-mb-30 rounded">
                            <h3 class="h5 g-color-primary g-mb-20">Looking to the Future</h3>
                            <p class="g-mb-0">
                                As NSIA Insurance looks ahead, its focus will always remain clear: improving digital
                                capabilities, creating tailored insurance solutions, and staying close to what customers
                                truly need in a fast-evolving world.
                            </p>
                        </div>

                        <p class="g-font-weight-600 g-font-size-18 g-mb-0">
                            Here's to 30 years of protecting what matters and many more years of impact to come.
                        </p>
                    </div>
                </article>
            </div>
            <div class="col-lg-3 g-mb-30">
                <!-- Links -->
                <app-sidebar></app-sidebar>
                <!-- End Fast Facts -->
            </div>
        </div>
    </div>
</div>
